import { motion } from "framer-motion";
import { CENTRAL_PA, STATES } from "./data";
import { Eyebrow, MaskLines, Reveal, EASE } from "./motion";

const Radar = () => (
  <div className="relative mx-auto aspect-square w-full max-w-[560px]" data-testid="coverage-radar">
    {[100, 74, 48].map((s, i) => (
      <motion.div
        key={s}
        initial={{ scale: 0.6, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.2, delay: i * 0.15, ease: EASE }}
        className="absolute left-1/2 top-1/2 rounded-full border border-white/10"
        style={{ width: `${s}%`, height: `${s}%`, marginLeft: `-${s / 2}%`, marginTop: `-${s / 2}%` }}
      />
    ))}
    <div className="radar-sweep absolute inset-[0%] rounded-full" />
    <div className="absolute left-1/2 top-1/2 h-[48%] w-[48%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-400/10" />
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
      <span className="relative mx-auto flex h-4 w-4">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-400/70" />
        <span className="relative inline-flex h-4 w-4 rounded-full bg-brand-400" />
      </span>
      <div className="mt-3 font-display text-lg font-bold text-white">Camp Hill</div>
      <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-300">HQ · Central PA</div>
    </div>
    {STATES.map((st, i) => (
      <motion.div
        key={st.code}
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.6, delay: 0.5 + i * 0.08, ease: EASE }}
        className="absolute -translate-x-1/2 -translate-y-1/2"
        style={{ left: `${st.x}%`, top: `${st.y}%` }}
        data-testid={`coverage-state-${st.code}`}
      >
        <div className="group rounded-full border border-white/15 bg-[#171717] px-3 py-1.5 font-mono text-xs font-bold text-zinc-100 transition-[border-color,color] duration-300 hover:border-brand-400 hover:text-brand-300">
          {st.code}
          <span className="pointer-events-none absolute left-1/2 top-full mt-2 -translate-x-1/2 whitespace-nowrap rounded bg-brand-400 px-2 py-1 text-[11px] text-[#0A0A0A] opacity-0 transition-opacity duration-300 group-hover:opacity-100">{st.name}</span>
        </div>
      </motion.div>
    ))}
  </div>
);

export const Coverage = () => (
  <section id="coverage" data-testid="coverage-section" className="relative overflow-hidden py-24 lg:py-36">
    <div className="mx-auto grid max-w-[1440px] items-center gap-16 px-5 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <Eyebrow index="05">Coverage</Eyebrow>
        <MaskLines className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-[-0.03em] text-white sm:text-5xl lg:text-6xl" lines={["Rooted in", "Camp Hill.", <span className="text-brand-400">Reaching further.</span>]} />
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-300 md:text-lg">
            We serve facilities all over Central Pennsylvania and in the surrounding states. Running multiple sites? One contract can cover them all.
          </p>
          <div className="mt-10 font-mono text-xs font-bold uppercase tracking-[0.22em] text-zinc-400">Central PA, including</div>
          <ul className="mt-4 flex flex-wrap gap-2" data-testid="coverage-cities">
            {CENTRAL_PA.map((c) => (
              <li key={c} className="rounded-full border border-white/10 px-3 py-1.5 text-sm text-zinc-200 transition-[border-color,color] duration-300 hover:border-brand-400/60 hover:text-white">{c}</li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Radar />
      </div>
    </div>
  </section>
);
